<template>
  <div :class="`input__wrapper ${className}`">
    <v-combobox
      ref="headerSearchRef"
      v-model="currentSearchValue"
      v-click-outside="false"
      solo
      no-filter
      return-object
      label=""
      color="white"
      item-text="name"
      height="41"
      :items="items"
      :loading="isLoading"
      :placeholder="placeholder"
      :search-input.sync="search"
      :clearable="$vuetify.breakpoint.xsOnly"
      clear-icon="mdi-close"
      @keydown.enter="onKeyDown"
      @input="handleValue"
    >
      <template #prepend-inner>
        <img
          width="24"
          height="24"
          src="../../../src/assets/search-icon.svg"
          alt=""
        />
      </template>
    </v-combobox>
  </div>
</template>

<script type="ts">
import { GlossaryApi } from '@gslc/models';
import { openApiConfig } from '../../api/config';
import { SEGMENT_EVENTS } from '../../constants';

const config = openApiConfig();
const glossaryApi = new GlossaryApi(config);
export default {
  data: () => ({
    isLoading: false,
    items: [],
    search: '',
    currentSearchValue: null,
    queryTerm: '',
    timeout: null,
    className: this.class,
  }),
  props: {
    placeholder: {
      type: String,
      default: 'Search our Glossary',
    },
    class: String,
  },
  watch: {
    '$route.query'() {
      this.handleRouteQuery();
    },
    search() {
      if (this.timeout) clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.fetchGlossary(this.search);
      }, 400);
    },
  },
  mounted() {
    this.handleRouteQuery();
  },
  methods: {
    handleRouteQuery() {
      const query = this.$route.query;
      if (query && !query.option && query.search) {
        this.currentSearchValue = query.search;
        this.search = query.search;
      } else {
        this.currentSearchValue = null;
        this.search = null;
      }
    },
    handleValue(value) {
      let searchTerm = '';
      if (typeof value === 'object' && value && value.name) {
        this.handleToGlossary(value.name);
        searchTerm = value.name;
      } else {
        this.fetchGlossary(value);
        searchTerm = value;
      }
      window.analytics.track(SEGMENT_EVENTS.HEADER_SEARCH, {
        searchTerm: String(searchTerm).toLocaleLowerCase(),
        contentType: 'Glossary',
      });
    },
    async fetchGlossary(text) {
      this.isLoading = true;
      const accessToken = await this.$auth.getTokenSilently();
      try {
        if (!accessToken) {
          this.isLoading = false;
          return;
        }
        const searchQuery = text ?? '';
        const glossaryResponse = await glossaryApi
          .searchGlossary(searchQuery, false, {
            headers: { Authorization: `Bearer ${accessToken}` },
          })
          .catch(e => console.error(e));
        const glossaries = glossaryResponse?.data?.data ?? [];
        var result = glossaries.map(g => {
          return { group: 'Glossary', name: g.name };
        });

        const itemsResulted = [];
        if (result.length > 0) {
          itemsResulted.push({ header: 'Glossary' }, ...result);
        }
        this.items = itemsResulted;
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoading = false;
      }
    },
    onKeyDown() {
      this.$refs.headerSearchRef.blur();
      this.handleToGlossary(this.search);
    },
    handleToGlossary(value) {
      this.items = [];
      if (
        this.$route?.name === 'Glossary' &&
        this.$route.query?.search !== value
      ) {
        this.$router.replace({
          name: 'Glossary',
          query: {
            search: value ? value : undefined,
          },
        });
      } else {
        if (!value) {
          return;
        } else if (this.$route.query?.search !== value) {
          this.$router.push({
            name: 'Glossary',
            query: {
              search: value,
            },
          });
        }
      }
    },
  },
};
</script>

<style scoped>
.input__wrapper >>> .v-input__slot {
  box-shadow: none !important;
  border: 1px solid #ccd3de;
  border-radius: 0 !important;
  margin-bottom: 0;
  min-height: initial;
}
.input__wrapper >>> .v-input__icon--clear > button {
  color: red !important;
}
@media (max-width: 600px) {
  .input__wrapper >>> input {
    font-size: 10px;
  }
}
.input__wrapper >>> .v-input__icon--append {
  display: none;
}
.input__wrapper >>> .searchBtn {
  background-color: var(--v-primary-base);
  color: white;
  font-weight: 800;
  font-size: 12px;
  padding: 0.5rem 1.2rem !important;
  box-shadow: 1px solid var(--v-primary-base);
  cursor: pointer;
}
.input__wrapper >>> .searchBtn:hover {
  box-shadow: 0px 4px 10px rgba(70, 156, 82, 0.24);
}
</style>
